var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:_vm.classes},[_c('div',{staticClass:"status-light"}),(_vm.hasDefaultSlot)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }